// extracted by mini-css-extract-plugin
module.exports = {"Container":"Benifits_Container__1vSdC","cards":"Benifits_cards__3LyO0","Card":"Benifits_Card__253dB"};